import React, { useEffect, useState, Fragment } from 'react';
import { Button, Modal, ModalHeader,ModalBody,ModalFooter } from 'reactstrap';
import requestApi from '../services/requestApi.service';
import { handleErrorResponse, getAppidFromCookie, getHostPrefix, getCookie, setCookie } from '../Common/Appcommon';
import cx from "classnames";


function WelcomePopup() {
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [wpEnabled, setWpEnabled] = useState(false);
    const prefix = getHostPrefix();

    const closePopup = () => {
        setCookie(prefix+"showPopup", "false",365,"");
        setIsModalOpen(false);
    };

    const handleClick = () =>{
        window.open('https://cratiocrm.com/overview-videos/', '_blank');
    }

    useEffect(() => {
        const fetchWpEnabledStatus = async () => {
            try {
                const appid = getAppidFromCookie();
                const params = {
                    'ENTITY': 'getRedirectPage',
                    "appid": appid,
                };
                const response = await requestApi.processServerRequest(params, "WebV2");
                if (response.issuccess) {
                    const today = new Date();
                    const last15Days = new Date();
                    last15Days.setDate(today.getDate() - 15);
                    const createdAt = new Date(response.data['createdon']);
                    if (createdAt > last15Days) {
                        if(createdAt != ''){
                            setWpEnabled(true);
                        }
                    }
                } else {
                    handleErrorResponse('Whatsapp Not Enabled');
                }
            } catch (error) {
                console.log('An error occurred');
            }
        };
        fetchWpEnabledStatus();
    }, []);
    
    const isPopUpShow = getCookie(prefix+'showPopup');
    const btnText = "Let's Go";

    return (
        <Fragment>
            {isModalOpen && wpEnabled && (isPopUpShow === undefined || isPopUpShow === null || isPopUpShow === '') && (
                <Modal isOpen={isModalOpen} >
                    <ModalHeader className='welcome-popup'>
                        Congrats! Your account is auto upgraded to Cratio 2.4 Version.
                    </ModalHeader>
                    <ModalBody>
                        <h4 className='welcome-popup-header'>What's New</h4>
                            <ul className='custom-bullet-list'>
                                <li>Responsive User Interface</li>
                                <li>Improved performance</li>
                                <li>Enhanced left menu</li>
                                <li>Workflow Automations</li>
                                <li>Lots of new Integrations</li>
                                <li>Connect to 1000+ apps via Pabbly, Webhooks</li>
                                <li>New Features (Paid Addons)</li>
                                <ul className='custom-bullet-list'>
                                    <li>Mobile Sales Call Tracking</li>
                                    <li>WhatsApp API Integration</li>
                                </ul>
                            </ul>
                            <button style={{ color: 'green',paddingLeft: '20px'}}onClick={handleClick}>Learn More</button>
                        </ModalBody>
                        <ModalFooter>
                        <Button className={`lePrimaryBtn br-4 welcome-popup-btn`} color="primary" onClick={closePopup}>
                            {btnText}
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
        </Fragment>
    );
}

export default WelcomePopup;
